import type { NextConfig } from 'next'
import { version } from './package.json'
const cdnEnabled = process.env.FF_CDN_ENABLED === '1' || false
const cdnUrl = process.env.CDN_URL

const config = (): NextConfig => {
  return {
    assetPrefix: cdnEnabled && cdnUrl ? `${cdnUrl}/sport/${version}/` : undefined,
    basePath: '/sport',
    env: {
      NEXT_PUBLIC_VERSION: version,
    },
    productionBrowserSourceMaps: true,
    poweredByHeader: false,
    trailingSlash: true,
    skipTrailingSlashRedirect: true,
    webpack(config) {
      config.module.rules.push({ test: /\.svg$/i, use: ['@svgr/webpack'] })
      return config
    },
    turbopack: {
      rules: { '*.svg': { loaders: ['@svgr/webpack'], as: '*.js' } },
    },
    images: {
      deviceSizes: [396],
      imageSizes: [124, 240, 360, 480, 768, 1024, 1200],
    },
  } as NextConfig
}
export default config
